import React, { Component } from 'react';
import ContentWrapper from '../../../components/Layout/ContentWrapper';


class PaymentCellFormatter extends Component {
  render() {
    return (
      <ContentWrapper>
        { React.cloneElement(this.props.children, { ...this.props }) }
      </ContentWrapper>
    );
  }
}

export default PaymentCellFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/EditAR/paymentCellFormatter.jsx